// extracted by mini-css-extract-plugin
module.exports = {"whatsapp-consent-wrapper":"SignupWhatsappConsentV2_whatsapp-consent-wrapper__9MG6D","text":"SignupWhatsappConsentV2_text__xEsEE"};